import { FunctionComponent, useEffect, useState } from 'react'
import { Daycare } from '@/types/Daycare'
import SelectUnique from '../_custom/Selector/selectUnique/selectUnique'
import { SelectOptionDeprecated, SelectOptionsDeprecated } from '@/types/Select'
import { useTranslation } from 'react-i18next'
import styles from './daycareSelector.module.scss'
import { Role } from '@/types/Role'
import { useAuth } from '@/modules/context/AuthContext'

interface DaycaresSelectorProps {
    removeBackground?: boolean
}

const DaycareSelector: FunctionComponent<DaycaresSelectorProps> = ({
    removeBackground = false
}: DaycaresSelectorProps) => {
    const { t } = useTranslation()

    const { user, setCurrentDaycare } = useAuth()

    const [daycareString, setDaycareString] = useState<string>(
        user?.currentDaycare
            ? user.currentDaycare.id.toString()
            : user && user.daycares.length > 0
              ? user.daycares[0].id.toString()
              : ''
    )

    const selectOptions: SelectOptionsDeprecated = [
        {
            options:
                user?.daycares
                    .filter((daycare: Daycare): boolean => (user?.role === Role.cald ? daycare.active === true : true))
                    .sort((a: Daycare, b: Daycare): number => a.city.localeCompare(b.city))
                    .map((daycare: Daycare): SelectOptionDeprecated => {
                        return {
                            name: daycare.city.toUpperCase() + ' - ' + daycare.name,
                            value: daycare.id.toString()
                        }
                    }) || []
        }
    ]

    useEffect(() => {
        const daycare: Daycare | undefined = user?.daycares.find(
            (daycare: Daycare): boolean => daycare.id.toString() === daycareString
        )
        if (daycare) {
            setCurrentDaycare(daycare.id)
        }
    }, [daycareString, user?.currentDaycare])

    return (
        <div className={`${styles.Container} ${user?.daycares.length === 1 && styles.Hide}`}>
            <div className={`${removeBackground ? styles.Selector : styles.SelectorWithBackground}`}>
                <SelectUnique
                    selectOptions={selectOptions}
                    selectValue={daycareString}
                    setSelectValue={setDaycareString}
                    label={t('myDaycares')}
                    parent={user?.role === Role.parent}
                />
            </div>
        </div>
    )
}

export default DaycareSelector
